var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.hasBtn
        ? _c(
            "div",
            { staticClass: "tab-btns" },
            [
              _vm.orderStatus == 0
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.onAction(
                            _vm.$t("OrdinaryOrderMix.GoodsInfoTab.Confirm")
                          )
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("OrdinaryOrderMix.GoodsInfoTab.Confirm"))
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.onAction(
                        _vm.$t("OrdinaryOrderMix.GoodsInfoTab.Pending")
                      )
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("OrdinaryOrderMix.GoodsInfoTab.Pending"))
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.onAction(
                        _vm.$t("OrdinaryOrderMix.GoodsInfoTab.Unhook")
                      )
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("OrdinaryOrderMix.GoodsInfoTab.Unhook")))]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          model: {
            value: _vm.goodsInfoActiveTab,
            callback: function ($$v) {
              _vm.goodsInfoActiveTab = $$v
            },
            expression: "goodsInfoActiveTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("OrdinaryOrderMix.GoodsInfoTab.Summarize"),
                name: "sku",
              },
            },
            [
              _vm.goodsInfoActiveTabHistory.has("sku")
                ? _c("SkuList", {
                    ref: "SkuList",
                    attrs: {
                      "order-id": _vm.orderId,
                      "has-btn": _vm.hasBtn,
                      "business-type": _vm.businessType,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("OrdinaryOrderMix.GoodsInfoTab.product"),
                name: "skuItem",
              },
            },
            [
              _vm.goodsInfoActiveTabHistory.has("skuItem")
                ? _c("SkuLineList", {
                    ref: "SkuLineList",
                    attrs: {
                      "order-id": _vm.orderId,
                      "has-btn": _vm.hasBtn,
                      "business-type": _vm.businessType,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }